import { Inject, Injectable, InjectionToken  } from '@angular/core';

export const BROWSER_STORAGE = new InjectionToken<Storage>('Browser Storage', {
  providedIn: 'root',
  factory: () => localStorage
});

@Injectable({
  providedIn: 'root'
})
export class BrowserStorageService {
  constructor(@Inject(BROWSER_STORAGE) public storage: Storage) {}

  public get(key: string) {
    return this.getItem(key);
  }

  public set(key: string, value: any) {
    this.setItem(key, value);
  }

  public remove(key: string) {
    this.removeItem(key);
  }
  
  public getItem(key: string) {
    return this.storage.getItem(key);
  }
  
  public setItem(key: string, value: any) {
    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }
    this.storage.setItem(key, value);
  }

  public removeItem(key: string) {
    this.storage.removeItem(key);
  }

  public clear() {
    this.storage.clear();
  }

}